// Helper function to determine place type from Nominatim result
export const getPlaceType = (type: string): string => {
  const lowerType = type.toLowerCase();

  if (lowerType.includes('building') || lowerType.includes('office')) return 'building';
  if (lowerType.includes('house') || lowerType.includes('residential')) return 'house';
  if (lowerType.includes('road') || lowerType.includes('highway') || lowerType.includes('street')) return 'road';
  if (lowerType.includes('city') || lowerType.includes('town') || lowerType.includes('village')) return 'city';
  if (lowerType.includes('shop') || lowerType.includes('store') || lowerType.includes('commercial')) return 'shop';
  if (lowerType.includes('restaurant') || lowerType.includes('cafe') || lowerType.includes('food')) return 'restaurant';
  if (lowerType.includes('hotel') || lowerType.includes('accommodation')) return 'hotel';
  if (lowerType.includes('tourism') || lowerType.includes('attraction') || lowerType.includes('museum')) return 'tourism';
  if (lowerType.includes('park') || lowerType.includes('recreation')) return 'park';
  if (lowerType.includes('school') || lowerType.includes('university') || lowerType.includes('education')) return 'school';
  if (lowerType.includes('hospital') || lowerType.includes('clinic') || lowerType.includes('medical')) return 'hospital';
  if (lowerType.includes('church') || lowerType.includes('temple') || lowerType.includes('religious')) return 'church';
  if (lowerType.includes('station') || lowerType.includes('transport')) return 'station';
  if (lowerType.includes('administrative') || lowerType.includes('government')) return 'administrative';
  if (lowerType.includes('industrial')) return 'industrial';
  if (lowerType.includes('amenity')) return 'amenity';

  return 'other';
};

// Helper function to get badge color based on place type
export const getBadgeColor = (placeType: string): string => {
  switch (placeType) {
    case 'building':
    case 'office':
      return 'blue';
    case 'house':
    case 'residential':
      return 'green';
    case 'road':
    case 'highway':
    case 'street':
      return 'gray';
    case 'city':
    case 'town':
    case 'village':
      return 'violet';
    case 'shop':
    case 'commercial':
      return 'orange';
    case 'restaurant':
      return 'red';
    case 'hotel':
      return 'pink';
    case 'tourism':
    case 'attraction':
      return 'cyan';
    case 'park':
      return 'lime';
    case 'school':
      return 'indigo';
    case 'hospital':
      return 'red';
    case 'church':
      return 'grape';
    case 'station':
      return 'dark';
    case 'administrative':
      return 'blue';
    case 'industrial':
      return 'gray';
    case 'amenity':
      return 'orange';
    default:
      return 'gray';
  }
};